import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-pt',
  templateUrl: './consulta-pt.component.html',
  styleUrls: ['./consulta-pt.component.scss']
})
export class ConsultaPtComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  @Input() token = '';

  constructor() { }

  ngOnInit() {
    this.setStatus();
  }

  ngOnChanges() {
    this.setStatus();
  }

  setStatus() {

    if(this.consulta) {
      if (this.consulta.ptPositivo == "N") {
        this.status = 'success';
        this.statusMsg = 'NÃO CONSTA OCORRÊNCIA';

      } else if (this.consulta.ptPositivo == "S") {
        this.status = 'danger';
        this.statusMsg = 'CONSTA OCORRÊNCIA';

      } else if(this.consulta.ptPositivo) {
        this.status = 'warning';
        this.statusMsg = 'RESULTADO NÃO ESPERADO, ENTRE EM CONTATO COM O SUPORTE';
      }
    }

    return { status: 'info', msg: null };
  }

}
